import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Grid, Row, Panel, Accordion } from 'react-bootstrap';
import { TextBox } from 'devextreme-react';
import { Button } from 'devextreme-react';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import "../data/data.css";
import Box, { Item } from 'devextreme-react/box';
import notify from 'devextreme/ui/notify';
import DataGrid, {
    Column, ColumnChooser, ColumnFixing, Sorting, Scrolling, Format, FilterRow, Paging, Selection,
    HeaderFilter,
    FilterPanel
} from 'devextreme-react/data-grid';
import { Popup } from 'devextreme-react/popup';

export default class BannerSwitch extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isActive: false        
        };
        this.checkTech = this.checkTech.bind(this);
        this.updateTech = this.updateTech.bind(this);

    }    

    checkTech() {
        fetch('api/main/CheckTech', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify()
        })
            .then(response => response.json())
            .then(data => {
                this.setState({ isActive: data });
            });
    }

    updateTech() {
        var tokenKey = "accessToken";

        var token = sessionStorage.getItem(tokenKey);
        fetch('api/main/UpdateTech', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            }
        })
            .then(() => {
                this.setState({isActive: !this.state.isActive})
            })
    }

    componentDidMount() {
        this.checkTech()
    }

    render() {
        return (
            <Grid fluid className="positionGrid">
                <Row>
                    <Col lg={8}>
                        <Box className="detailLine"
                            direction={'row'}
                            width={'40%'}
                            height={'auto'}>
                            <Item
                                ratio={1}>
                                <div className="testClass">
                                    <div className="verticalContent">Технические работы</div>
                                </div>
                            </Item>
                            <Item
                                ratio={0}
                                baseSize={220}>
                                <div className="testClass">
                                    <div className="verticalContent">
                                        <Button className="toolboxButton" id="button"
                                            type={'default'}
                                            stylingMode={'contained'}
                                            width={200}
                                            height={36}
                                            text={this.state.isActive ? 'Отключить' : 'Включить'}
                                            onClick={this.updateTech}
                                        >
                                        </Button>
                                    </div>
                                </div>
                            </Item>
                        </Box>
                    </Col>
                </Row>
            </Grid>
            )
        }
}


// WEBPACK FOOTER //
// ./App/containers/banner/bannerSwitch.jsx